export default [
	{
		key: 'monthly',
		length: 30,
		name: '1 Month',
		binWidth: 7
	},
	{
		key: 'quarterly',
		length: 90,
		name: '3 Months',
		binWidth: 7
	}
]
